/* SealBags — tiny interaction layer. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal() {
    var els = document.querySelectorAll('.sb-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function counters() {
    var nums = document.querySelectorAll('[data-sb-count]');
    if (!nums.length) return;
    var run = function (el) {
      var raw = el.getAttribute('data-sb-count');
      var target = parseFloat(raw); if (isNaN(target)) return;
      var decimals = (raw.split('.')[1] || '').length;
      var start = performance.now(), dur = 1100;
      (function step(t) {
        var p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      })(start);
    };
    if (reduce || !('IntersectionObserver' in window)) { nums.forEach(function (el) { el.textContent = el.getAttribute('data-sb-count'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }
  function init() { reveal(); counters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('page:loaded', init);
})();